import React, { useState } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import ReCAPTCHA from "react-google-recaptcha";

function ContactForm() {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: "",
    });

    const [captchaValue, setCaptchaValue] = useState(null);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(null);
    const [error, setError] = useState(null);

    // Handle form input changes
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    // Handle CAPTCHA validation
    const handleCaptchaChange = (value) => {
        setCaptchaValue(value);
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        setSuccess(null);

        // Step 1: Validate CAPTCHA
        if (!captchaValue) {
            setError("Please complete the CAPTCHA.");
            setLoading(false);
            return;
        }

        try {
            // Verify CAPTCHA first
            /*const captchaResponse = await fetch("https://www.google.com/recaptcha/api/siteverify", {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: new URLSearchParams({
                    secret: "6Ldp6s4qAAAAAEfZxbtr8wKWPbhApGLLR0HxkJ9q", // Replace with your reCAPTCHA secret key
                    response: captchaValue,
                }),
            });

            const captchaResult = await captchaResponse.json();

            if (!captchaResult.success) {
                setError("CAPTCHA validation failed. Please try again.");
                setLoading(false);
                return;
            }*/

            // Step 2: Send the form data to backend
            const response = await fetch("https://orbyte.se/api/contact.php", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    name: formData.name,
                    email: formData.email,
                    message: formData.message,
                    captcha: captchaValue,
                }),
            });

            const result = await response.json();

            if (response.ok) {
                setSuccess("Your message has been sent!");
                setFormData({ name: "", email: "", message: "" });
                setCaptchaValue(null);
            } else {
                setError(result.error || "Something went wrong.");
            }
        } catch (err) {
            console.log(err)
        } finally {
            setLoading(false);
        }
    };

    return (
        <Row className="justify-content-center">
            <Col md={6}>
                <Form onSubmit={handleSubmit} className="p-4 bg-light text-dark border-0 rounded-3 shadow-sm">
                    <Form.Group className="mb-3">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                            type="text"
                            name="name"
                            placeholder="Enter your name"
                            className="form-control-lg"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            type="email"
                            name="email"
                            placeholder="Enter your email"
                            className="form-control-lg"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Message</Form.Label>
                        <Form.Control
                            as="textarea"
                            name="message"
                            rows={4}
                            placeholder="Your message"
                            className="form-control-lg"
                            value={formData.message}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>

                    <ReCAPTCHA sitekey="6Ldp6s4qAAAAAKGgruQmm4r0CNDNp9nlE3obTpxx" onChange={handleCaptchaChange} />

                    {error && <p className="text-danger mt-3">{error}</p>}
                    {success && <p className="text-success mt-3">{success}</p>}

                    <Button variant="primary" type="submit" className="w-100 btn-lg shadow-sm mt-3" disabled={loading}>
                        {loading ? "Sending..." : "Send Inquiry"}
                    </Button>
                </Form>
            </Col>
        </Row>
    );
}

export default ContactForm;
